<template>
    <div>
        <H2 style="padding-top:40px;text-align: center;margin-top: calc(100vw * 70 / 1920)">个人信息保护及隐私政策</H2>
        <div style="text-align:justify; text-justify:inter-ideograph;margin-left:auto;margin-right:auto;width:70%;white-space:pre-wrap;padding-left: 30px;padding-right: 30px" v-html="content">
        </div>
        <div style="margin-left:auto;margin-right:auto;text-align: right;width:70%;margin-bottom: 40px">北京蜜堂有信科技有限公司</div>
    </div>

</template>

<script>
    export default {
        name: "Protocol",
        data(){
            return{
                content:'\n' +
                    '     北京蜜堂有信科技有限公司（“蜜堂有信”或“我们”）在向用户提供方便、安全的产品。同时，致力于提升信息处理的安全性、保障您的信息安全。蜜堂有信严格遵守法律法规、遵循以下隐私保护原则，以期为您提供更加安全、可靠的技术服务。\n' +
                    '         \n' +
                    '     蜜堂有信“隐私政策”适用于您使用蜜堂产品时，我们收集和使用您的个人信息及其他相关必要信息。我们将通过蜜堂产品向您提供服务云端收款技术服务（以下简称“云设备”服务），这些服务将实现您在自有应用系统发起订单、推送到云设备实现面对面收款。\n' +
                    '         \n' +
                    '     本隐私政策（以下称“本政策”）将向您说明，我们如何收集、使用、共享和保护您的个人信息及其他相关信息，请您在使用我们提供的服务前，务必仔细阅读本《隐私政策》，在充分了解并同意后，使用我们提供的服务。如果您不同意本隐私政策的任何内容，您应立即停止使用我们的服务。当您开始使用我们提供的服务时，即表示您已同意我们按照本政策来收集、处理、存储、使用、共享和保护您的个人信息。我们将尽最大的努力保护好您的个人信息。\n' +
                    '         \n' +
                    '     我们可能会对本政策进行修改、如有-重大更改（例如：业务功能，使用目的，个人信息保护相关联系方式等变更），我们将在新版隐私政策正式生效前，通过页面通知的方式在蜜堂有信官网和蜜堂产品上公布新版隐私政策，方便您了解具体变化并向我们提出建议。如果您继续使用我们的服务即被是视为对新版隐私协议的接收。\n' +
                    '         \n' +
                    '     本政策最近更新及生效日期：2020年07月01日。\n' +
                    '         \n' +
                    '     本隐私政策主要包含以下内容：\n' +
                    '         \n' +
                    '     一、本政策的适用范围\n' +
                    '         \n' +
                    '     二、个人信息的定义与范围\n' +
                    '         \n' +
                    '     三、信息的收集方式与使用\n' +
                    '         \n' +
                    '     四、信息的共享及披露\n' +
                    '         \n' +
                    '     五、如何保存和保护您的个人信息\n' +
                    '         \n' +
                    '     六、您如何管理您的个人信息\n' +
                    '         \n' +
                    '     七、如何保护未成年人的个人信息\n' +
                    '         \n' +
                    '     八、协议更新\n' +
                    '         \n' +
                    '     九、适用法律\n' +
                    '         \n' +
                    '     十、如何联系我们\n' +
                    '         \n' +
                    '     一、本政策的适用范围\n' +
                    '     本政策适用于蜜堂产品所有服务。\n' +
                    '         \n' +
                    '     二、个人信息的定义与范围\n' +
                    '     个人信息：是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。本政策中涉及的个人信息包括：基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证等）；网络身份标识信息（包括系统账号、IP地址、人脸照片）；个人财产信息（交易和消费记录、银行卡信息等虚拟财产信息）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型、软件列表唯一设备识别码（如IMEI/androidID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）；个人位置信息（包括行程信息、精准定位信息、经纬度等）；\n' +
                    '         \n' +
                    '     个人敏感信息：是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息，在本政策中包括：手机号码、身份证或其他身份证明、位置信息、人脸照片。\n' +
                    '         \n' +
                    '     匿名化处理后的信息：即通过对个人信息的技术处理，使得个人信息主体无法被识别，且处理后不能被复原的信息，匿名化处理后的信息不属于个人信息。其他无法识别特定自然人身份或者反映特定自然人活动情况的信息不属于个人信息。\n' +
                    '         \n' +
                    '     三、信息的收集方式与使用\n' +
                    '     我们仅会出于本政策所述的以下目的，收集和使用您的个人信息：为了遵守法律法规的要求，向您提供更好以及更个性化的服务，并努力提高您的用户体验。您向我们提供下述信息或使用我们的服务时，即表示您同意我们按照本政策规定收集信息。\n' +
                    '         \n' +
                    '         <br>（一）个人信息的收集\n' +
                    '     1、您向我们提供的信息\n' +
                    '         \n' +
                    '     为了遵守法律法规的要求，以及向您提供更个性化、更便捷高效的服务，我们需要识别您的身份，当您激活及您在使用我们的相关服务时，需要您填写、提交及/或以其他任何方式提供您的个人信息。\n' +
                    '         \n' +
                    '     我们在您使用服务过程中获得的信息\n' +
                    '         \n' +
                    '     为了提升服务质量和用户体验，我们会留存您使用服务以及相关使用方式的信息，这类信息包括：\n' +
                    '         \n' +
                    '         <br>（1）您的位置信息，我们将收集您的位置信息，用于您在确定的经营地点使用我们的云设备。在您首次使用前，我们会提示您选择是否允许产品获取以及何种情况下可以获取您的位置信息。在您使用的过程中，您可以随时通过您的设备设置功能，选择是否允许产品获取以及何种情况下可以获取您的位置信息。获得您的允许后，我们会通过IP地址、GPS以及能够提供相关信息的其他传感器（如附近设备、Wi-Fi接入点和基站信息）来获取您的位置信息。如果您拒绝产品获取位置信息，服务将中断。\n' +
                    '         \n' +
                    '         <br>（2）订单信息及交易状态。我们将记录您的订单信息及交易状态。我们收集上述信息是基于您业务对账、业务退款等的需要。\n' +
                    '         \n' +
                    '         <br>（3）为开展数据分析和更好地保障收款安全，我们可能会收集您的日志信息，例如您的硬件设备型号、屏幕宽度和高度、您所使用的软件版本信息、您的操作系统及版本、您的IP地址、您所在的位置、移动网络信息、您的设备ID、设备制造商、设备型号、运营商、IMEI/androidID/IDFA/OPENUDID/GUID、SIM卡IMSI信息；\n' +
                    '         \n' +
                    '     您提供的上述信息及上述被获取的信息，将在您使用本服务期间持续授权我们使用。除非法律对存储时间有特殊要求，在您注销账号时，我们将停止使用并匿名化上述信息。上述信息将存储于中华人民共和国境内。\n' +
                    '         \n' +
                    '     3、我们调用的设备权限\n' +
                    '         <br>（1）产品可能会调用您的一些设备权限，以下是调用权限对应的业务功能，我们调用权限的目的，以及调用权限前向您询问的情况。\n' +
                    '         \n' +
                    '         <br>（2）您可以在设备的设置功能中选择关闭部分或全部权限，从而拒绝产品收集相应的个人信息。使用ios或Android系统的不同设备中，权限显示方式和关闭方式可能有所不同，具体请联系设备及系统开发方。但关闭部分功能，可能会影响到您使用云设备收款服务。\n' +
                    '         \n' +
                    '         <br>（3）Android系统权限调用\n' +
                    '         \n' +
                    '         <br>设备权限\t对应的业务功能\t调用权限的目的\t是否询问\t用户是否可关闭权限\n' +
                    '         <br>位置信息\t全部业务功能\t获取定位\t首次使用APP时弹窗提示\t是\n' +
                    '         <br>无线数据\t全部功能\t连接网络\t否\t是\n' +
                    '     存储（APP 公共存储区域）\t核心业务功能\t存储和读取地图服务、读取存储用户信息、存储日志\t首次使用该功能时弹窗提示\t是\n' +
                    '     相册/相机\t核心业务功能\t收款服务，提供二维码扫码或人脸扫描\t首次使用该功能时弹窗提示\t是\n' +
                    '         <br>麦克风\t核心业务功能\t收款服务，提示付款人\t首次使用该功能时弹窗提示\t是\n' +
                    '         <br>NFC \t核心业务功能\t收款服务，挥卡服务\t    首次使用该功能时弹窗提示\t是\n' +
                    '         \n' +
                    '         \n' +
                    '     4、Cookie及同类技术的使用\n' +
                    '         \n' +
                    '     为实现您联机体验的个性化需求，使您获得更轻松的访问体验。我们会在您的计 算机或移动设备上发送一个或多个名为Cookies的小数据文件，指定给您的Cookies是唯一的，它只能被将Cookies发布给您的域中的Web服务器读取。我们向您发送Cookies是为了简化您重复登录的步骤、存储您的购物偏好或您购物车中的商品等数据进而为您提供购物的偏好设置、帮助您优化对广告的选择与互动、帮助判断您的登录状态以及账户或数据安全。\n' +
                    '         \n' +
                    '     我们不会将Cookies用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookies。您可以清除计算机上保存的所有Cookies，大部分网络浏览器会自动接受Cookies，但您通常可根据自己的需要来修改浏览器的 设置以拒绝Cookies；另外，您也可以清除软件内保存的所有Cookies。但如果您这么做，您可能需要在每一次访问蜜堂有信网站时亲自更改用户设置，而且您之前所记录的相应信息也均会被删除，并且可能会对您所使用服务的安全性有 一定影响。\n' +
                    '         \n' +
                    '     除Cookies外，我们还会在网站上使用网络Beacon等其他同类技术。我们的 网页上常会包含一些电子图像（称为"单像素"GIF文件或"网络Beacon"）。我们使用网络Beacon的方式有：\n' +
                    '         \n' +
                    '         <br>（1）通过在蜜堂有信网站上使用网络Beacon，计算用户访问数量，并通过访问Cookies辨认注册的蜜堂有信用户。\n' +
                    '         \n' +
                    '         <br>（2）通过得到的Cookies信息，为您提供个性化服务。\n' +
                    '         \n' +
                    '         <br>（二）个人信息的使用\n' +
                    '     为向您提供服务、提升我们的服务质量以及优化您的服务体验，我们会在符合法律规定或获得您授权的情况下使用您的个人信息，并主要用于下列用途：\n' +
                    '         \n' +
                    '     1、向您提供您使用的各项服务，并维护、改进这些服务。\n' +
                    '         \n' +
                    '     2、我们可能使用您的个人信息以验证身份，预防、发现、调查可能存在的欺诈、危害安全、非法或违反与我们或关联方协议、政策或规则的行为，以保护您、其他用户、我们或关联方的合法权益。\n' +
                    '         \n' +
                    '     3、我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，以展示我们的产品或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。\n' +
                    '         \n' +
                    '     4、请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：\n' +
                    '         \n' +
                    '     a)与国家安全、国防安全有关的；\n' +
                    '         \n' +
                    '     b)与公共安全、公共卫生、重大公共利益有关的；\n' +
                    '         \n' +
                    '     c)与犯罪侦查、起诉、审判和判决执行等有关的；\n' +
                    '         \n' +
                    '     d)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；\n' +
                    '         \n' +
                    '     e)所收集的个人信息是个人信息主体自行向社会公众公开的；\n' +
                    '         \n' +
                    '     f)从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；\n' +
                    '         \n' +
                    '     g)根据您的要求签订合同所必需的；\n' +
                    '         \n' +
                    '     h)用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；\n' +
                    '         \n' +
                    '     i)为合法的新闻报道所必需的；\n' +
                    '         \n' +
                    '     j)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；\n' +
                    '         \n' +
                    '     k)法律法规规定的其他情形。\n' +
                    '         \n' +
                    '     l)经您同意或授权的其他用途。\n' +
                    '         \n' +
                    '     四、信息的共享及披露\n' +
                    '         <br>（一）您如何共享、公开披露您的个人信息\n' +
                    '     我们的产品不涉及共享、公开披露您的个人信息的情况。\n' +
                    '         \n' +
                    '         <br>（二）我们如何共享、转让、公开披露您的个人信息\n' +
                    '     我们不会将您的个人信息共享、转让、公开披露给蜜堂有信及其关联公司以外的任何第三方，但以下情况除外：\n' +
                    '         \n' +
                    '     1、获得您的同意或授权。\n' +
                    '         \n' +
                    '     2、根据法律法规的规定或行政、司法机构等有权机关的要求或者授权。\n' +
                    '         \n' +
                    '     3、我们与第三方进行联合营销活动，我们可能与其共享活动过程中产生的、为完成活动所必要的个人信息，如参加活动的用户数、中奖名单、中奖人联系方式等，以便第三方能及时向您发放奖品。与授权合作伙伴共享。仅为实现本政策 中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们的合作伙伴无权将共享的个人信息用于任何其他用途。\n' +
                    '         \n' +
                    '     4、根据法律规定及合理商业习惯，在我们计划与其他公司合并或被其收购或进行其他资本市场活动时，以及其他情形下我们需要接受来自其他主体的尽职调查时，我们会把您的信息提供给必要的主体，但我们会通过和这些主体签署保密协议等方式要求其对您的个人信息采取合理的保密措施。随着我们业务的发展，我们及我们的关联方有可能进行合并、收购、资产转让或类似的交易，您的个人 信息有可能作为此类交易的一部分而被转移。\n' +
                    '         \n' +
                    '     5、您出现违反法律、法规规定或者违反您与我们签署的相关协议（包括在线签署的电子协议）或相关规则时需要向第三方披露的情形。\n' +
                    '         \n' +
                    '     6、为维护我们及关联方或其他用户的合法权益，在协助处理与您有关的交易纠纷或争议时，我们可能向您的交易相对方或存在利害关系的第三方提供解决交易纠纷或争议所必需的信息。\n' +
                    '         \n' +
                    '     7、根据法律规定，刑事侦查机关为调查犯罪，依法定程序调取的必要个人信息；或行政机关、司法机构，依法定程序并经您授权同意调取的必要个人信息，我们会向其提供您的相关信息；非经法定程序或未获得您的同意，我们不会将您的个人信息提供给任何第三方机构或个人。\n' +
                    '         \n' +
                    '     五、如何保存和保护您的个人信息\n' +
                    '         <br>（一）如何保存您的个人信息\n' +
                    '         \n' +
                    '     1、按照相关法律法规规定，我们将把中华人民共和国境内运营过程中收集和产生的您的个人信息存储在中国境内。如部分服务涉及跨境业务，我们需要向境外机构传输境内收集的相关个人信息的，我们会按照法律法规和相关监管部门的 规定执行，向您说明个人信息出境的目的以及涉及的个人信息类型，征得您的同意，并通过签订协议、现场核查等有效措施，要求境外机构为所获得的您的个人信息保密。\n' +
                    '         \n' +
                    '     2、在您使用蜜堂产品服务期间，我们会持续保存您的个人信息。\n' +
                    '         \n' +
                    '     3、如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。\n' +
                    '         \n' +
                    '     4、除下述情形外，您可以自主删除个人信息或注销账户：\n' +
                    '         \n' +
                    '     a)为配合人民检察院、公安机关、国家安全机关侦查用户使用蜜堂有信服务过程中产生的犯罪行为，更好保护其他用户生命财产安全，为配合人民法院查清案情，您的个人信息和账户将被保存；\n' +
                    '         \n' +
                    '     b)为遵守法律法规、政策等关于个人信息的保存期限的规定。当您自主删除个人信息或注销账户，我们将按照法律、法规及本协议规定的最短期限保留您的现有个人信息，在法律法规要求的最短保存期限内，我们将不再对您的个人信息进行商业化使用。当您的个人信息超出上述保存期限，我们将会对其进行匿名化处理。\n' +
                    '         \n' +
                    '         <br>（二）如何保护您的个人信息\n' +
                    '         \n' +
                    '     我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：\n' +
                    '         \n' +
                    '     1、我们会采用符合业界标准的安全防护措施，包括建立合理的制度规范、安全技术来防止您的个人信息遭到未经授权的访问使用、修改，避免数据的损坏或丢失。\n' +
                    '         \n' +
                    '     2、如我们停止“蜜堂有信”业务，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。\n' +
                    '         \n' +
                    '     3、采取了内部管理制度和技术保障措施等多方面的保护方式以保护您的个人信息，具体而言包括但不限于以下方面：\n' +
                    '         \n' +
                    '     a）内部管理制度上，我们根据数据的敏感程度和类型的不同采取了数据分类分级制度，并根据分类分级结果进行使用者权限、使用场景权限、使用授权权限、分级审批机制等多方面的权限限制；对于超期储存的个人信息，我们将删除您的个人信息。\n' +
                    '         \n' +
                    '     b)技术保障措施上，我们在存储时采取了不可逆的加密存储、隔离存储，在信息展示和下载时采取了脱敏处理，传输时采取了专线传输、加密传输、密钥和数据介质隔离传输等技术措施，以确保您的个人信息安全。\n' +
                    '         \n' +
                    '     c)定期安全审计上，我们通过审计机制来对隐私政策和相关规程的有效性以及数据安全进行全面核查与控制。我们将定期更新并公开安全风险、个人信息安全影响评估等报告的有关内容。\n' +
                    '         \n' +
                    '     d)机制保障上，我们设立了个人信息保护小组，针对个人信息收集、使用、共享、委托处理等开展个人信息安全影响评估。同时，我们不断对工作人员培训相关法律法规及隐私安全准则和安全意识强化宣导，并每年组织全体工作人员参加安全考试。\n' +
                    '         \n' +
                    '     e)我们已制定相关的信息安全事件应急预案，定期组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。\n' +
                    '         \n' +
                    '     5、互联网环境并非百分之百安全，我们将尽力确保您发送给我们的任何信息的安全性。在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。\n' +
                    '         \n' +
                    '     请注意，单独的设备信息、搜索关键词信息等无法与任何特定个人直接建立联系的数据，不属于个人信息。如果我们将这类非个人信息与其他信息结合用于识别 自然人个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类设备信息将被视为个人信息。我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非 需要延长保留期或受到法律的允许。\n' +
                    '         \n' +
                    '         <br>（三）安全事件处置\n' +
                    '         \n' +
                    '     在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。\n' +
                    '         \n' +
                    '     六、您如何管理您的个人信息\n' +
                    '     产品不提供信息修改功能，终止服务时，将按照相关法律要求处理您的个人信息。\n' +
                    '         \n' +
                    '     七、如何保护未成年人的个人信息\n' +
                    '     产品不支持未成年人激活服务的功能。\n' +
                    '         \n' +
                    '     八、协议更新\n' +
                    '     随着网络平台信息服务的进一步提升，本隐私政策也将随之更新。我们会通过产品客户端上发出更新版本、发送推送通知或以其他方式提醒您相关内容的更新，也请定期查看本页以了解我们对于隐私保护的最新措施。\n' +
                    '         \n' +
                    '     九、适用法律\n' +
                    '     本隐私政策的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律。\n' +
                    '         \n' +
                    '     十、如何联系我们\n' +
                    '     1、如对本政策有任何疑问，您可以通过蜜堂有信公布的联系方式与我们联系，我们将会解 答您的疑问并尽力解决。\n' +
                    '         \n' +
                    '     2、如果您对我们的回复不满意，特别是认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向被告住所地有管辖权的法院诉讼来寻求解决方案。\n' +
                    '         \n' +
                    '         \n'
            }
        }
    }
</script>

<style scoped>

</style>